export default __webpack_public_path__ + "3238abaff6f802df97126ea7d5cc5937.png";